import type { Minor } from '@mt/protocol';

/** Число кругов ставок в розыгрыше (этапы 1–3). */
export const ROUNDS = 3;

/** Правила стола. Все суммы — в минорных единицах (1 кр. = 100). */
export interface TableRules {
  /** обязательный взнос N, вносится до первого круга */
  ante: Minor;
  /** минимальная первая ставка круга */
  minBet: Minor;
  /** допустимое число повышений после первой ставки в круге */
  maxRaisesPerRound: number;
  /** время на ход, мс */
  turnMs: number;
  /** комиссия, базисные пункты от новых взносов круга (500 = 5%) */
  commissionBps: number;
  /** открытый верхний предел комиссии по кругам (null — без предела) */
  commissionCapPerRound: (Minor | null)[];
  /** шаг цены индекса, пункты */
  tick: number;
  /**
   * В скольких первых кругах (и в подготовке) можно выбирать и менять направление;
   * в остальных меняется только число пунктов. «Слепая тройка» — 2, «Открытые карты» — 1.
   */
  directionRounds: number;
}

export function defaultRules(ante: Minor, overrides: Partial<TableRules> = {}): TableRules {
  return {
    ante,
    minBet: ante,
    maxRaisesPerRound: 1,
    turnMs: 12_000,
    commissionBps: 500,
    commissionCapPerRound: [null, null, null],
    tick: 0.25,
    directionRounds: 2,
    ...overrides,
  };
}
